export function RnD() {
  const points = [
    {
      title: "AI-Guided Machine Learning",
      text: "Adaptive control models that learn from millions of operating cycles to optimise mix accuracy and energy use in real time.",
    },
    {
      title: "Digital Twin Validation",
      text: "Every machine is simulated, stress-tested, and refined in a virtual environment before a single component is fabricated.",
    },
    {
      title: "Predictive Maintenance",
      text: "Embedded sensors forecast wear and component fatigue, eliminating unplanned downtime across the fleet.",
    },
  ];

  return (
    <section id="rnd" className="relative overflow-hidden bg-slate-950 py-24 text-white">
      <div className="pointer-events-none absolute inset-0 opacity-[0.12] [background-image:linear-gradient(rgba(45,212,191,0.6)_1px,transparent_1px),linear-gradient(90deg,rgba(45,212,191,0.6)_1px,transparent_1px)] [background-size:48px_48px]" />
      <div className="absolute -left-32 top-1/4 h-72 w-72 rounded-full bg-teal-500/20 blur-3xl" />
      <div className="absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-cyan-500/10 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-teal-400">
            R&D & Engineering Excellence
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Inside our state-of-the-art R&D center
          </h2>
          <p className="mt-5 text-slate-300">
            Where new technologies like AI-guided machine learning are
            integrated into every layer of design. We engineer at the
            intersection of precision mechanics and intelligent systems —
            turning data into durability.
          </p>

          <div className="mt-10 space-y-6">
            {points.map((p, i) => (
              <div key={p.title} className="flex gap-4">
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm border border-teal-400/40 bg-teal-500/10 font-mono text-xs font-bold text-teal-300">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div>
                  <h3 className="font-semibold text-white">{p.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-slate-400">
                    {p.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute inset-0 -m-2 rounded-lg border border-teal-400/20" />
          <div className="relative overflow-hidden rounded-lg border border-teal-400/30 shadow-xl shadow-teal-900/40">
            <img
              src="/images/rnd-schematic.webp"
              alt="Glowing machine schematic"
              width={1600}
              height={1200}
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 to-transparent" />
            <div className="absolute bottom-5 left-5 rounded-lg bg-slate-950/70 px-4 py-2 text-xs font-medium text-teal-300 backdrop-blur">
              Live schematic · component analysis
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
